module.exports = __webpack_public_path__ + "img/Solar.814065f4.jpg";